<template>
  <div class="variable-group">
    <div v-if="!group.root" class="variable-group-header" @click="(isOpen = !isOpen), groupsOnly ? selectGroup() : ''">
      <span :style="{ 'padding-left': (depth - 1) * 15 + 20 + 'px' }">{{ group.name | capitalize }}</span>
      <div :class="{ 'flip-chevron': isOpen }">
        <i class="fa-light fa-chevron-down"></i>
      </div>
    </div>
    <div v-if="isOpen || group.root" class="variable-group-content">
      <variable-group
        v-for="group in filteredGroups"
        :key="group.name"
        :group="group"
        :allNames="combinedNames + group.name"
        :depth="depth + 1"
        :filter="filter"
        :show-values="showValues"
        :selected-variable-name="selectedVariableName"
        :open="filter ? group.hasVariable(selectedVariableName || filter) : false"
        @variable-selected="(variable) => $emit('variable-selected', variable)"
        :groupsOnly="groupsOnly"
        :variableTypeFilters="variableTypeFilters"
      />
      <div v-if="!groupsOnly">
        <div
          v-for="variable in filteredAndSpecificVariables"
          :key="variable.name"
          :class="{ 'is-selected': variable.name === selectedVariableName }"
          class="variable-item"
          :title="showValueOnHover ? variable.value || variable.name : variable.name"
          :style="{ 'padding-left': depth * 15 + 20 + 'px' }"
          @click="$emit('variable-selected', variable.name)"
        >
          <!-- <scroll-to :scroll="variable.name === selectedVariableName" /> -->
          <span class="variable-text d-flex">
            <span>
              {{ getPrettyName(variable) | capitalize }}
              <div v-if="showValues" class="text-muted text-xs variable-item-value">
                {{
                  variable.custom
                    ? $t("variables.calculated")
                    : variable.value == null
                    ? $t("var-group.no-value")
                    : variable.value.toString().substr(0, 32) + (variable.value.toString().length > 32 ? ".." : "")
                }}
              </div>
            </span>
            <div class="variable-text-type text-xs">{{ variable.type }}</div>
          </span>
        </div>
      </div>
    </div>
    <!-- <div v-for="(variableOrGroup, key) in group" :key="key">
			<template v-else-if="variableOrGroup.isGroup">
				<div class="variable-group-header" @click="isOpen = !isOpen">
					<span>{{key}}</span>
					<img :src="isOpen ? require('@/assets/svg/chevronUp.svg') : require('@/assets/svg/chevronDown.svg')" />
				</div>
				<variable-group v-if="isOpen" :group="variableOrGroup" />
			</template>
			<div v-else :class="{'is-selected': variableOrGroup.name === selectedVariableName}" @click="$emit('variable-name-changed', variableOrGroup.name)" class="variable-item" :title="variableOrGroup.name">
				<span>{{getPrettyName(variableOrGroup)}}</span>
				<img src="@/assets/svg/chevronRight.svg" />
			</div>
		</div> -->
  </div>
</template>

<script>
import VariableHelpers from "@/assets/js/variableHelpers.js";
import VariableGroup from "@/components/VariableGroup";
export default {
  name: "variable-group",
  props: {
    group: {
      type: Object,
      required: true,
    },
    selectedVariableName: {
      type: String,
    },
    filter: {
      type: String,
    },
    open: {
      type: Boolean,
    },
    showValues: Boolean,
    depth: {
      type: Number,
      default: 0,
    },
    allNames: String,
    groupsOnly: Boolean,
    variableTypeFilters: Array,
    showValueOnHover: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      name: this.group.name,
      // allNames: this.combinedNames
      isSelected: false,
    };
  },
  computed: {
    filteredGroups() {
      return this.filter ? this.group.groups.filter((g) => g.contains(this.filter)) : this.group.groups;
    },
    filteredVariables() {
      return this.filter
        ? this.group.variables.filter((v) => {
            let name = v.name.toLowerCase();
            return this.filter
              .split(" ")
              .every(
                (filterSegment) =>
                  name.indexOf(filterSegment) > -1 || (v.displayName || "").toLowerCase().indexOf(filterSegment) > -1,
              );
          })
        : this.group.variables;
    },
    combinedNames() {
      if (!this.allNames) return this.name;
      else return this.allNames + "_";
    },
    filteredAndSpecificVariables() {
      return this.variableTypeFilters && this.variableTypeFilters.length > 0
        ? this.filteredVariables.filter((v) => this.variableTypeFilters.includes(v.type))
        : this.filteredVariables;
    },
  },
  methods: {
    selectGroup() {
      // To do - Make it so you can select the path for where you wanna put your new extraVariable.
      console.log("select me");
      // this.isSelected = true
    },
    isFilterMatch(variableOrGroup, filter) {
      if (variableOrGroup.name === undefined) {
        // is group
        return Object.values(variableOrGroup).some((v) => this.isFilterMatch(v, filter));
      } else
        return (
          variableOrGroup.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 ||
          (variableOrGroup.displayName || "").toLowerCase().indexOf(filter.toLowerCase()) > -1
        );
    },
    getPrettyName(variable) {
      return VariableHelpers.extractPrettyNameVariableOnly(variable);
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(isOpen) {
        if (isOpen) this.isOpen = isOpen;
      },
    },
    filter: function() {
      //Makes sure that all groups close when search input is emptied
      if (this.filter == "") {
        this.isOpen = false;
      }
    },
  },
  components: {
    VariableGroup,
  },
};
</script>

<style lang="less">
.variable-group {
  line-height: 24px;
  cursor: default;

  .variable-group-header,
  .variable-item {
    padding-right: 14px;
    display: flex;
    span {
      flex-grow: 1;
    }
  }

  .variable-group-header {
    font-weight: 500;
    &:hover {
      background-color: rgba(219, 218, 218, 0.4);
    }
  }

  .variable-item {
    line-height: 1em;
    padding-top: 5px;
    padding-bottom: 5px;
    img,
    svg {
      display: none;
    }
    &:hover {
      background-color: rgba(219, 218, 218, 0.4);
      > img,
      svg {
        display: block;
      }
    }

    &.is-selected {
      background-color: rgba(219, 218, 218);
    }

    .variable-item-value {
      margin-top: 2px;
    }
  }

  .flip-chevron {
    transform: rotate(180deg);
  }
  .fa-chevron-down {
    font-size: 12px;
  }
}
// .variable-group:last-child{
// 	padding-bottom: 60px;
// }

.variable-text-type {
  white-space: nowrap;
  align-self: start;
  padding: 2px 4px;
  border-radius: var(--standard-border-radius);
  // background: var(--charcoal-75);
  // color: var(--alabaster);
  // background: var(--alabaster);
  color: var(--charcoal-50);
}
.no-border {
  border: 0 none;
}
</style>
